import { Component, Input, Output, EventEmitter, ChangeDetectionStrategy } from '@angular/core';
import { HttpResponse } from '@angular/common/http';
import { FileService } from '../file/file.service';
import { NgxSpinnerService } from 'ngx-spinner';
import { saveAs } from 'file-saver-es';
import { ErrorModalService } from '../modal/error.modal.service';
import { TranslateService } from '@ngx-translate/core';

@Component({
    selector: 'file-link-fromgk',
    template: `
  @if (fileId || fileName) {
    <button type="button" (click)="getFile()" class="btn nowrap-btn" [ngClass]="{'btn-link': !isButton, 'w-100 btn-garanti btn-blue btn-lg': isButton}" [title]="fileName"><fa-icon [icon]="['fas', style.icon]" size="lg" [fixedWidth]="true" class="me-2" [style.color]="style.color"></fa-icon>{{ fileName }}</button>
  }`,
    styles: [`
  .btn.active.focus, .btn.active:focus, .btn.focus, .btn:active.focus, .btn:active:focus, .btn:focus {
     outline: 0;
     outline-offset: 0;
   }
   .btn-link {
     padding: 0;
   }`],
    changeDetection: ChangeDetectionStrategy.Eager,
    standalone: false
})
export class FileLinkFromGkComponent {
  @Input() fileName: string;
  @Input() fileId: string;
  @Input() caption: string;
  @Input() isButton: boolean;
  @Input() requestId: string;
  @Input() creditorCaseId: string;
  @Input() creditorId: string;
  @Output()
  public onSuccess: EventEmitter<any> = new EventEmitter();

  constructor(
    protected fileService: FileService,
    protected spinner: NgxSpinnerService,
    protected errorModalService: ErrorModalService,
    protected translate: TranslateService) {
  }

  public get style(): { icon: string, color?: string } {
    switch (this.getFileExtension()) {
      case '.pdf':
        return { icon: 'file-pdf', color: '#C0392B' };

      case '.doc':
      case '.docx':
        return { icon: 'file-word', color: '#2C5A78' };

      case '.xls':
      case '.xlsx':
        return { icon: 'file-excel', color: '#1F7A50' };

      default:
        return { icon: 'file' };
    }
  };

  private getFileExtension(): string {
    return this.fileName?.split('.')?.pop()?.toLowerCase() ?? '';
  }

  public getFile(): void {
    this.spinner.show();

    if (this.creditorCaseId) {
      this.fileService.getFileFromGkCreditor(this.fileId, this.creditorCaseId, this.creditorId).subscribe(
        (response: HttpResponse<ArrayBuffer>) => {
          this.spinner.hide();
          const blob = new Blob([response.body]);
          saveAs(blob, this.fileName);

          if (this.onSuccess) this.onSuccess.emit();
        },
        (error) => {
          this.spinner.hide();
          this.errorModalService.open(this.translate.instant('modal.unknown-error'), this.translate.instant('error.could-not-fetch-file'));
        });
    }
    else {
      this.fileService.getFileFromGk(this.requestId, this.fileId, this.fileName).subscribe(
        (response: HttpResponse<ArrayBuffer>) => {
          this.spinner.hide();
          const blob = new Blob([response.body]);
          saveAs(blob, this.fileName);

          if (this.onSuccess) this.onSuccess.emit();
        },
        (error) => {
          this.spinner.hide();
          this.errorModalService.open(this.translate.instant('modal.unknown-error'), this.translate.instant('error.could-not-fetch-file'));
        });
    }
  }
}
